/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var IconRow = /*#__PURE__*/function (_HTMLElement) {
  _inherits(IconRow, _HTMLElement);
  var _super = _createSuper(IconRow);
  // The constructor is called when an object is created with the class
  function IconRow() {
    var _this;
    _classCallCheck(this, IconRow);
    _this = _super.call(this); // Call the parent class constructor
    _this.originalStateText = _this.querySelector('span[original-text]');
    _this.alternativeStateText = _this.querySelector('span[alternative-text]');
    _this.minimumAmount = parseInt(_this.getAttribute('minimum-amount'));
    _this.productAmount = parseInt(_this.getAttribute('product-amount'));
    return _this;
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  _createClass(IconRow, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.updateStates();
      // document.addEventListener("product:updated", (event) => {
      //     this.productAmount = event.detail.cart.total_price;
      //     console.log(this.cartAmount);
      //     this.updateStates();
      // });
    }
  }, {
    key: "updateStates",
    value: function updateStates() {
      if (this.productAmount >= this.minimumAmount) {
        this.originalStateText.style.display = 'none';
        this.alternativeStateText.style.display = 'block';
      } else {
        this.originalStateText.style.display = 'block';
        this.alternativeStateText.style.display = 'none';
      }
    }
  }]);
  return IconRow;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the custom element
customElements.define("icon-row", IconRow);

// Version 1 Gallery JavaScript
function initializeVersion1Gallery() {
  console.log('Version 1 Gallery JavaScript Loaded');

  // Desktop thumbnails now use native CSS scroll - no Swiper needed

  // Set dynamic height for thumbnail container based on main gallery
  function setThumbnailContainerHeight() {
    var mainGallery = document.querySelector('.product__gallery-container--version-1 .product__images');
    var thumbnailContainer = document.querySelector('.product__thumbnails-container--version-1');
    var firstThumbnail = document.querySelector('.product__thumbnail--version-1');
    if (mainGallery && thumbnailContainer && firstThumbnail) {
      // Calculate height to show exactly 4 thumbnails
      var thumbnailHeight = firstThumbnail.offsetHeight;
      var rowGap = 5; // 5px gap between thumbnails

      // Calculate: 4 thumbnails + 3 gaps between them
      var calculatedHeight = thumbnailHeight * 4 + rowGap * 3;

      // Ensure we have a minimum height (fallback)
      if (calculatedHeight === 0 || thumbnailHeight === 0) {
        // Set a reasonable default height if we can't get the thumbnail height
        calculatedHeight = 100 * 4 + 5 * 3; // Assuming 100px thumbnail height
      }

      // Set the max-height of thumbnail container to show 4 thumbnails
      thumbnailContainer.style.maxHeight = calculatedHeight + 'px';

      // Set visibility to visible after calculating height
      thumbnailContainer.style.visibility = 'visible';
      console.log('Set thumbnail container max-height to show 4 thumbnails:', calculatedHeight + 'px', 'Thumbnail height:', thumbnailHeight + 'px');
    }
  }

  // Set initial height
  setThumbnailContainerHeight();

  // Update height on window resize
  window.addEventListener('resize', function () {
    setThumbnailContainerHeight();
  });

  // Also update when images load (in case gallery height changes)
  var galleryImages = document.querySelectorAll('.product__images img');
  galleryImages.forEach(function (img) {
    if (img.complete) {
      setThumbnailContainerHeight();
    } else {
      img.addEventListener('load', setThumbnailContainerHeight);
    }
  });

  // Initialize version 1 gallery immediately since we prevent default initialization
  var mobileSwiper = document.querySelector('[data-product-images-v1]');
  var paginationEl = document.querySelector('.product__mobile-pagination');
  console.log('Mobile Swiper Element:', mobileSwiper);
  console.log('Pagination Element:', paginationEl);
  if (mobileSwiper && typeof Swiper !== 'undefined') {
    console.log('Creating Swiper with pagination for Version 1');

    // Destroy any existing swiper instance created by product.js
    if (mobileSwiper.swiper) {
      console.log('Destroying existing mobile swiper instance');
      mobileSwiper.swiper.destroy(true, true);
    }
    var swiperInstance = new Swiper(mobileSwiper, {
      spaceBetween: 3,
      slidesPerView: 1.1,
      loop: false,
      pagination: {
        el: '.product__mobile-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function renderBullet(index, className) {
          return '<span class="' + className + '"></span>';
        }
      },
      on: {
        init: function init() {
          console.log('Version 1 Swiper initialized with pagination');
        }
      }
    });

    // Store the swiper instance for potential future reference
    mobileSwiper.swiperInstance = swiperInstance;
    console.log('Version 1 Swiper Instance:', swiperInstance);
  } else {
    console.log('Swiper element or Swiper library not found');
  }

  // Handle Version 1 thumbnails functionality
  var version1Thumbnails = document.querySelectorAll('.product__thumbnail--version-1');
  if (version1Thumbnails.length > 0) {
    version1Thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function (e) {
        e.preventDefault();

        // Remove active class from all thumbnails
        version1Thumbnails.forEach(function (thumb) {
          thumb.classList.remove('active');
        });

        // Add active class to clicked thumbnail
        thumbnail.classList.add('active');

        // Get the image ID and show corresponding main image
        var imageId = thumbnail.getAttribute('data-image-id');
        var mainImages = document.querySelectorAll('[data-product-image-wrapper]');
        mainImages.forEach(function (imageWrapper) {
          if (imageWrapper.getAttribute('data-image-id') === imageId) {
            imageWrapper.classList.remove('hide');
          } else {
            imageWrapper.classList.add('hide');
          }
        });
      });
    });
  }
}

// Version 2 Gallery JavaScript
function initializeVersion2Gallery() {
  console.log('Version 2 Gallery JavaScript Loaded');

  // Initialize Swiper for thumbnails with free mode
  var thumbnailsWrapper = document.querySelector('.product__thumbnails-wrapper--version-2');
  var thumbnailsSwiper = null;
  if (thumbnailsWrapper && typeof Swiper !== 'undefined') {
    console.log('Creating Swiper for Version 2 thumbnails');
    thumbnailsSwiper = new Swiper(thumbnailsWrapper, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: {
        enabled: true,
        sticky: false
      },
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto'
        }
      },
      on: {
        init: function init() {
          console.log('Version 2 Thumbnails Swiper initialized with free mode');
        }
      }
    });
  }

  // Handle Version 2 thumbnails functionality
  var version2Thumbnails = document.querySelectorAll('.product__thumbnail--version-2');
  var currentSlideElDesktop = document.querySelector('.product__pagination-counter--desktop .current-slide');
  var currentSlideElMobile = document.querySelector('.product__pagination-counter--mobile .current-slide');
  var totalSlidesElDesktop = document.querySelector('.product__pagination-counter--desktop .total-slides');
  var totalSlidesElMobile = document.querySelector('.product__pagination-counter--mobile .total-slides');
  if (version2Thumbnails.length > 0) {
    version2Thumbnails.forEach(function (thumbnail, index) {
      thumbnail.addEventListener('click', function (e) {
        e.preventDefault();

        // Remove active class from all thumbnails
        version2Thumbnails.forEach(function (thumb) {
          thumb.classList.remove('active');
        });

        // Add active class to clicked thumbnail
        thumbnail.classList.add('active');

        // Update pagination counter for both desktop and mobile
        var thumbnailIndex = parseInt(thumbnail.getAttribute('data-thumbnail-index'));
        if (currentSlideElDesktop) {
          currentSlideElDesktop.textContent = thumbnailIndex;
        }
        if (currentSlideElMobile) {
          currentSlideElMobile.textContent = thumbnailIndex;
        }

        // Get the image ID and show corresponding main image
        var imageId = thumbnail.getAttribute('data-image-id');
        var mainImages = document.querySelectorAll('[data-product-image-wrapper]');
        mainImages.forEach(function (imageWrapper) {
          if (imageWrapper.getAttribute('data-image-id') === imageId) {
            imageWrapper.classList.remove('hide');
          } else {
            imageWrapper.classList.add('hide');
          }
        });

        // Auto-scroll thumbnail into view using Swiper
        if (thumbnailsSwiper) {
          var slideIndex = Array.from(version2Thumbnails).indexOf(thumbnail);
          thumbnailsSwiper.slideToClickedSlide = true;
          // Center the clicked slide in the view
          var swiperSlides = thumbnailsSwiper.slides;
          if (swiperSlides[slideIndex]) {
            thumbnailsSwiper.slideTo(slideIndex, 300);
          }
        }
      });
    });

    // Initialize first thumbnail as active and update counter
    if (version2Thumbnails[0]) {
      version2Thumbnails[0].classList.add('active');
      if (currentSlideElDesktop) {
        currentSlideElDesktop.textContent = '1';
      }
      if (currentSlideElMobile) {
        currentSlideElMobile.textContent = '1';
      }
    }

    // Keyboard and mouse wheel navigation is now handled by Swiper
    // Swiper provides better performance and smoother interactions
  }

  // Initialize mobile swiper for version 2 (main gallery)
  var mobileSwiper = document.querySelector('[data-product-images]');
  var mobileThumbnailsSwiper = document.querySelector('.product__mobile-thumbnails--version-2');
  var mobileThumbnails = document.querySelectorAll('.product__mobile-thumbnail');
  if (mobileSwiper && typeof Swiper !== 'undefined' && !mobileSwiper.querySelector('[data-product-images-v1]')) {
    console.log('Creating mobile Swiper for Version 2');

    // Destroy any existing swiper instance
    if (mobileSwiper.swiper) {
      mobileSwiper.swiper.destroy(true, true);
    }
    var swiperInstance = new Swiper(mobileSwiper, {
      spaceBetween: 8,
      slidesPerView: 1,
      centeredSlides: true,
      loop: false,
      navigation: {
        nextEl: '[data-mobile-nav-next]',
        prevEl: '[data-mobile-nav-prev]'
      },
      on: {
        init: function init() {
          console.log('Version 2 Mobile Swiper initialized');
        },
        slideChange: function slideChange() {
          // Update both desktop and mobile pagination counters to match mobile slide
          if (currentSlideElDesktop) {
            currentSlideElDesktop.textContent = this.activeIndex + 1;
          }
          if (currentSlideElMobile) {
            currentSlideElMobile.textContent = this.activeIndex + 1;
          }

          // Update mobile thumbnails active state
          if (mobileThumbnails.length > 0) {
            mobileThumbnails.forEach(function (thumb, index) {
              if (index === this.activeIndex) {
                thumb.classList.add('active');
              } else {
                thumb.classList.remove('active');
              }
            }, this);

            // Auto-scroll mobile thumbnail into view
            if (mobileThumbnailsSwiperInstance && mobileThumbnails[this.activeIndex]) {
              mobileThumbnailsSwiperInstance.slideTo(this.activeIndex, 300);
            }
          }
        }
      }
    });
    mobileSwiper.swiperInstance = swiperInstance;
  }

  // Initialize mobile thumbnails swiper
  var mobileThumbnailsSwiperInstance = null;
  if (mobileThumbnailsSwiper && typeof Swiper !== 'undefined') {
    console.log('Creating mobile thumbnails Swiper for Version 2');
    mobileThumbnailsSwiperInstance = new Swiper(mobileThumbnailsSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: {
        enabled: true,
        sticky: false
      },
      watchSlidesProgress: true,
      on: {
        init: function init() {
          console.log('Version 2 Mobile Thumbnails Swiper initialized');
        }
      }
    });

    // Handle mobile thumbnail clicks
    if (mobileThumbnails.length > 0) {
      mobileThumbnails.forEach(function (thumbnail, index) {
        thumbnail.addEventListener('click', function (e) {
          e.preventDefault();

          // Update main mobile swiper
          if (mobileSwiper.swiperInstance) {
            mobileSwiper.swiperInstance.slideTo(index, 300);
          }

          // Update pagination counter
          var thumbnailIndex = parseInt(thumbnail.getAttribute('data-thumbnail-index'));
          if (currentSlideElDesktop) {
            currentSlideElDesktop.textContent = thumbnailIndex;
          }
          if (currentSlideElMobile) {
            currentSlideElMobile.textContent = thumbnailIndex;
          }

          // Update desktop gallery
          var imageId = thumbnail.getAttribute('data-image-id');
          var mainImages = document.querySelectorAll('[data-product-image-wrapper]');
          mainImages.forEach(function (imageWrapper) {
            if (imageWrapper.getAttribute('data-image-id') === imageId) {
              imageWrapper.classList.remove('hide');
            } else {
              imageWrapper.classList.add('hide');
            }
          });

          // Update desktop thumbnails active state
          version2Thumbnails.forEach(function (thumb) {
            if (thumb.getAttribute('data-image-id') === imageId) {
              thumb.classList.add('active');
            } else {
              thumb.classList.remove('active');
            }
          });
        });
      });
    }
  }
}

// Initialize Galleries when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  // Check if this is a product page
  var productContainer = document.querySelector('[data-product]');
  if (productContainer) {
    // Check for version 1
    var version1Elements = document.querySelector('.product__thumbnails-container--version-1');
    if (version1Elements) {
      initializeVersion1Gallery();
    }

    // Check for version 2
    var version2Elements = document.querySelector('.product__thumbnails-container--version-2');
    if (version2Elements) {
      initializeVersion2Gallery();
    }
  }
});

/***/ }),

/***/ "./src/scss/sr-custom.scss":
/*!*********************************!*\
  !*** ./src/scss/sr-custom.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/sr-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkBushbalm_Ca"] = self["webpackChunkBushbalm_Ca"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/scss/sr-custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;